import React from 'react';
import { ArrowUpRightIcon } from 'lucide-react';
const elsewhere = [{
  label: 'LinkedIn',
  href: 'https://www.linkedin.com/in/prashanthsekhar'
}];
export function Contact() {
  return <section id="contact" data-id="element-13" data-mp="316ab67m0yqyl">
      <div className="mx-auto max-w-page px-6 py-20 lg:px-10 lg:py-28" data-id="element-14" data-mp="317le657nbuon">
        <div className="grid gap-10 lg:grid-cols-12" data-id="element-15" data-mp="2w80axilg1064">
          <div className="lg:col-span-4" data-id="element-16" data-mp="2w9bi7se3kq1z">
            <p className="font-sans text-[12px] uppercase tracking-overline text-muted" data-id="element-17" data-mp="3sy9bf6678fx1">Contact</p>
          </div>

          <div className="lg:col-span-8" data-id="element-18" data-mp="3ovw8sqmr0y4h">
            <h2 className="max-w-[18ch] font-serif text-[clamp(2rem,5vw,4rem)] leading-[1.02] tracking-[-0.02em] text-ink" data-id="element-19" data-mp="3oy8wlkf6u2pg">
              If you are building something, or protecting what you built — write to me.
            </h2>

            <a href="mailto:mail@prashanthsekhar.com" className="group mt-10 inline-flex items-baseline gap-3 border-b-2 border-ink pb-2 font-serif text-[clamp(1.4rem,3.5vw,2.5rem)] leading-none text-ink transition-colors duration-150 ease-out hover:border-accent hover:text-accent focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent focus-visible:ring-offset-4 focus-visible:ring-offset-paper" data-id="element-20" data-mp="gg2qc68uxcks">
              mail@prashanthsekhar.com
              <ArrowUpRightIcon aria-hidden="true" className="h-6 w-6 shrink-0 transition-transform duration-200 ease-expo group-hover:-translate-y-0.5 group-hover:translate-x-0.5" data-id="element-21" data-mp="3f4mjdi7m3uhm" />
            </a>

            <p className="mt-8 max-w-[54ch] font-sans text-[15px] leading-[1.7] text-ink-soft" data-id="element-22" data-mp="365rbm1ox6cc7">
              I read everything myself. Useful things to include: what you are working on or
              worried about, and what you would want from me — advice, an introduction, a board
              seat or a talk.
            </p>

            <ul className="mt-10 flex flex-wrap gap-x-8 gap-y-3 border-t border-rule pt-6" data-id="element-23" data-mp="qb7iamdpi372">
              {elsewhere.map(link => <li key={link.label} data-id="element-24" data-mp="23bu80nyrm2ii">
                  <a href={link.href} target="_blank" rel="noreferrer" className="font-sans text-[13px] uppercase tracking-[0.14em] text-muted transition-colors duration-150 ease-out hover:text-ink focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent focus-visible:ring-offset-4 focus-visible:ring-offset-paper" data-id="element-25" data-mp="23cvjuunlut1a">
                    {link.label}
                  </a>
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}